import { Box } from 'components/Box';
import { Button } from 'components/Button';
import { Card } from 'components/Card';
import TermsAndConditionsModal from 'pages/inviteFriends/partials/TermsAndConditionsModal/TermsAndConditionsModal.loadable';
import UserDownloadContractOnFooter from 'pages/profile/partials/UserDownloadContractOnFooter/UserDownloadContractoOnFooter.component';
import { useState } from 'react';
import { Translate } from 'react-localize-redux';
import { Text } from 'style/text.style';
import { mainSiteLinks } from 'utils/consts/main-site-links';
import { useGetSiteIdParamForExternalRedirect } from 'utils/hooks/useGetIsApp';

type TermsAndConditionsComponentProps = {
  isInsideDrawer?: boolean;
};

export default function TermsAndConditionsComponent({
  isInsideDrawer,
}: TermsAndConditionsComponentProps) {
  const [termsAndConditionsModalOn, setTermsAndConditionsModalOn] =
    useState(false);
  const siteIdParam = useGetSiteIdParamForExternalRedirect();

  return (
    <Card
      width={'100%'}
      marginBottom={isInsideDrawer ? 0 : '20px'}
      borderRadius={isInsideDrawer ? '0' : undefined}
    >
      <Text as="h3" margin={'0 0 8px'} textSize={'16px'} textWeight={600}>
        <Translate id="lbl.termsAndConditions" />
      </Text>
      <Text as="p" margin={'0'} textSize={'14px'}>
        <Translate id="footer.lbl.subtitle.termsAndConditions" />
      </Text>
      <Box display={'flex'} gap={'20px'} marginTop={'36px'}>
        <UserDownloadContractOnFooter />
        <Button variant="ghost" height={'unset'} padding="0">
          <Text textDecoration={'underline'}>
            <Translate
              id="lbl.termsAndConditions.cta"
              data={{ href: `${mainSiteLinks.terms}${siteIdParam}` }}
            />
          </Text>
        </Button>
      </Box>
      {termsAndConditionsModalOn && (
        <TermsAndConditionsModal
          i18nHeading
          heading={'lbl.termsAndConditions'}
          onClose={() => setTermsAndConditionsModalOn(false)}
        />
      )}
    </Card>
  );
}
